export enum EPacksSort {
  Name = 'name',
  UserName = 'user_name',
  Date = 'updated',
  CardsCount = 'cardsCount',
}
